// @flow

import React, { Component } from 'react';
import {Icon} from 'react-fa';
import RaisedButton from 'material-ui/RaisedButton';
import _ from 'lodash';

import './css/MapButtons.css';



type T_MapButtonProps = {
  label      : string,
  fun        : () => void,
  rfun?      : () => void,
  icon?      : string,
  cond?      : boolean,
  bgcolor?   : string,
  color?     : string,
  tip?       : string,
  idtip?     : string,
  spin?      : boolean,
  pulse?     : boolean,
  disabled?  : boolean,
  id?        : string,
  icon_right?: boolean
};



export class MapButton extends Component<T_MapButtonProps> {
  click = (ev: SyntheticMouseEvent<*>) => {
    if (ev.button === 0 && ! this.props.disabled) {
      this.props.fun();
    }
  }
  
  
  
  rclick = (ev: Event) => {
    if (ev.type === 'contextmenu') {
      ev.preventDefault();
      
      if (this.props.rfun != null && _.isFunction(this.props.rfun)) {
        this.props.rfun();
      }
    }
  }
  
  
  
  render() {
    if (_.has(this.props, 'cond') && ! this.props.cond) {
      return null;
    }
    
    const style = {paddingBottom: this.props.spin ? 0 : 3, color: this.props.color || 'black'},
          id = this.props.id ? {id: this.props.id} : {};
    
    return (
      <div className='ButtonBar' data-tip={this.props.tip} data-for={this.props.idtip} onContextMenu={this.rclick} {...id}>
        <RaisedButton
          label={this.props.label}
          onClick={this.click}
          style={{marginLeft: 5, height: 28}}
          fullWidth={false}
          icon={
            this.props.icon &&
            <Icon
              name={this.props.icon}
              spin={this.props.spin}
              pulse={this.props.pulse != null ? this.props.pulse : false}
              style={style}
            />
          }
          labelPosition={this.props.icon_right ? 'before' : 'after'}
          backgroundColor={this.props.disabled ? 'lightgray' : this.props.bgcolor || 'white'}
          labelStyle={{textTransform: 'none', fontWeight: 400, color: this.props.color || 'black'}}
        />
      </div>
    );    
  }
}




type T_MapIconProps = {
  icon?    : string,
  tip      : string,
  fun      : () => void,
  rfun?    : () => void,
  cond?    : boolean,
  label?   : string,
  disabled?: boolean,
  spin?    : boolean,
  pulse?   : boolean,
  id?      : string,
  bg?      : string
};



export class MapIcon extends Component<T_MapIconProps> {
  click = (ev: SyntheticMouseEvent<*>) => {
    if (ev.button === 0 && ! this.props.disabled) {
      this.props.fun();
    }
  }
  
  
  
  rclick = (ev: Event) => {
    if (ev.type === 'contextmenu') {
      ev.preventDefault();
      
      if (this.props.rfun != null && _.isFunction(this.props.rfun)) {
        this.props.rfun();
      }
    }
  }
  
  
  
  render() {
    if (_.has(this.props, 'cond') && ! this.props.cond) {
      return null;
    }
    
    const style = {background: (this.props.disabled ? 'lightgray' : (this.props.bg || '#ffffff'))},
          id = this.props.id ? {id: this.props.id} : {};
    
    return (
      <div title={this.props.tip} style={style} className='mapButton_fake' onClick={this.click} onContextMenu={this.rclick} {...id}>
        <p>
          {this.props.icon &&
            <Icon name={this.props.icon} spin={this.props.spin || false} pulse={this.props.pulse || false} />
          }
          
          {this.props.label &&
            <span>
              {this.props.label}
            </span>
          }
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MapButtons.jsx